/* global $:true */
import debug from "debug";
import plugin from "@core/lib/plugin";

import googleMapsApiPromise from "@vendor/google-maps-api";

const ELEMENT_SELECTOR = "[data-address-autocomplete]";
const STATE_ELEMENT_ATTR = "data-address-autocomplete-state-field";
const SUBURB_ELEMENT_ATTR = "data-address-autocomplete-suburb-field";
const POSTCODE_ELEMENT_ATTR = "data-address-autocomplete-postcode-field";
const COUNTRY_ELEMENT_ATTR = "data-address-autocomplete-country-field";
const ADDRESS_LINE_0_ELEMENT_ATTR = "data-address-autocomplete-line0-field";
const ADDRESS_LINE_1_ELEMENT_ATTR = "data-address-autocomplete-line1-field";
const RESTRICT_TO_COUNTRY_ELEMENT_ATTR =
	"data-address-autocomplete-restrict-to-country-field";

const PLUGIN_NAME = "addressAutocomplete";
const MODULE_NAME = "app.core/modules/address-autocomplete";
const log = debug(MODULE_NAME);


log("registerd");

class AddressAutocomplete {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$addressLine0 = $(this.$element.attr(ADDRESS_LINE_0_ELEMENT_ATTR));
		this.$addressLine1 = $(this.$element.attr(ADDRESS_LINE_1_ELEMENT_ATTR));
		this.$suburbField = $(this.$element.attr(SUBURB_ELEMENT_ATTR));
		this.$stateField = $(this.$element.attr(STATE_ELEMENT_ATTR));
		this.$postcodeField = $(this.$element.attr(POSTCODE_ELEMENT_ATTR));
		this.$countryField = $(this.$element.attr(COUNTRY_ELEMENT_ATTR));
		this.countryCode = this.$element.attr(RESTRICT_TO_COUNTRY_ELEMENT_ATTR);

		log("construct", element);
		this.preventSubmit();

		googleMapsApiPromise.then((google) => {
			this.google = google;
		}).then(this.init.bind(this));
	}

	loadAutoCompleteAPI(params) {
		var script = document.createElement("script");

		script.type = "text/javascript";

		script.src = urlBuilder({
			base: "https://maps.googleapis.com/maps/api/js",
			libraries: params.libraries || [],
			callback: "googleMapsAutoCompleteAPILoad",
			apiKey: params.apiKey,
			client: params.client,
		});

		document.querySelector("head").appendChild(script);
	}

	preventSubmit() {
		if (this.$element.closest("form").length) {
			log(
				"preventSubmit.enabled [Preventing form submission on ENTER press.]"
			);

			this.$element.on("keypress", (event) => {
				if (event.keyCode === 13) {
					event.preventDefault();
					log("preventSubmit.keypress", event.keyCode);
				}
			});
		}
	}

	init() {
		var options = {};

		if (
			typeof this.countryCode !== "undefined" &&
			this.countryCode.length > 0
		) {
			options["componentRestrictions"] = { country: this.countryCode };
		}

		var el = this.$element.attr("id");

		// Google global
		window.gm_authFailure = this.handleGoogleAuthFailure.bind(this);

		var autocomplete = new this.google.maps.places.Autocomplete(
			document.getElementById(el),
			options
		);
		autocomplete.setFields([
			"formatted_address",
			"geometry",
			"address_component",
		]);

		this.autocomplete = autocomplete;
		this.changeListener = autocomplete.addListener(
			"place_changed",
			this.fillInAddress.bind(this)
		);
		log("init");
	}

	handleGoogleAuthFailure() {
		google.maps.event.clearInstanceListeners(this.element);
		this.element.removeAttribute("disabled");
		this.element.removeAttribute("autocomplete");
		this.element.classList.remove("pac-target-input");
		this.element.classList.remove("gm-err-autocomplete");
		this.element.style = "";
		this.element.placeholder = "";
	}

	triggerInput(element) {
		element.dispatchEvent(new Event("input"));
	}

	fillInAddress() {
		var place = this.autocomplete.getPlace();
		var elementVal = this.$element.val();
		log("fillInAddress", place);
		this.$element.trigger({ type: "place_selected", place });

		if (
			typeof this.$addressLine0 !== "undefined" &&
			this.$addressLine0.length > 0
		) {
			this.$addressLine0.val("");
			this.$addressLine0.attr("disabled", false);
		}
		if (
			typeof this.$suburbField !== "undefined" &&
			this.$suburbField.length > 0
		) {
			this.$suburbField.val("");
			this.$suburbField.attr("disabled", false);
		}
		if (
			typeof this.$stateField !== "undefined" &&
			this.$stateField.length > 0
		) {
			this.$stateField.val("");
			this.$stateField.attr("disabled", false);
		}
		if (
			typeof this.$postcodeField !== "undefined" &&
			this.$postcodeField.length > 0
		) {
			this.$postcodeField.val("");
			this.$postcodeField.attr("disabled", false);
		}
		if (
			typeof this.$countryField !== "undefined" &&
			this.$countryField.length > 0
		) {
			this.$countryField.val("");
			this.$countryField.attr("disabled", false);
		}

		var addressLine0 = "";
		var addressLine1 = "";
		var premise = "";
		var subpremise = "";
		var route = "";
		var postBox = "";
		var postalTown = "";
		var administrative_area_level_1 = "";
		var administrative_area_level_2 = "";
		var locality = "";
		var postcode = "";
		var countryCode = "";

		for (var i = 0; i < place.address_components.length; i++) {
			var addressType = place.address_components[i].types[0];

			if (addressType == "post_box") {
				postBox =
					place.address_components[i][
						this.options.componentForm["post_box"]
					];
			}
			if (addressType == "premise") {
				premise =
					place.address_components[i][
						this.options.componentForm["premise"]
					];
			}
			if (addressType == "subpremise") {
				subpremise =
					place.address_components[i][
						this.options.componentForm["subpremise"]
					];
			}
			if (addressType == "street_number") {
				addressLine1 =
					addressLine1.length == 0
						? place.address_components[i][
								this.options.componentForm["street_number"]
						  ]
						: addressLine1;
			}
			if (addressType == "route") {
				route =
					place.address_components[i][
						this.options.componentForm["route"]
					];

				// Retain unit numbers entered in form.
				var regex = RegExp("^(.*)" + route.split(" ", 1)[0]),
					result = regex.exec(elementVal);

				if (Array.isArray(result)) {
					addressLine1 = result[1];
				}
			}
			if (addressType == "postal_town") {
				postalTown =
					place.address_components[i][
						this.options.componentForm["postal_town"]
					];
			}
			if (addressType == "locality" || addressType == "colloquial_area") {
				locality =
					place.address_components[i][
						this.options.componentForm["locality"]
					];
			}
			if (addressType == "administrative_area_level_2") {
				administrative_area_level_2 =
					place.address_components[i][
						this.options.componentForm[
							"administrative_area_level_2"
						]
					];
			}

			if (addressType == "administrative_area_level_1") {
				administrative_area_level_1 =
					place.address_components[i][
						this.options.componentForm[
							"administrative_area_level_1"
						]
					];
			}

			if (addressType == "postal_code") {
				postcode =
					place.address_components[i][
						this.options.componentForm["postal_code"]
					];
			}

			if (addressType == "country") {
				countryCode =
					place.address_components[i][
						this.options.componentForm["country"]
					];
			}
		}

		if (locality.length == 0) {
			locality = postalTown;
		}
		if (locality.length == 0) {
			locality = administrative_area_level_2;
		}

		var add0 = subpremise.length > 0 ? subpremise + " " : "";
		add0 = add0.length > 0 ? add0 : addressLine0;
		add0.trim();

		var add1 = postBox.length > 0 ? "PO BOX " + postBox + " " : "";
		add1 += premise.length > 0 ? premise + " " : "";
		add1 += addressLine1.length > 0 ? addressLine1 + " " : "";
		add1 += route;
		add1.trim();

		if (this.countryCode === 'USA') {
			this.$element.val([add1, add0].join(' '));
		} else {
			this.$element.val(add1);
		}

		if (
			typeof this.$addressLine0 !== "undefined"
			&& this.$addressLine0.length > 0
		) {
			this.$addressLine0.val(add0);
			this.triggerInput(this.$addressLine0[0]);
		}

		if (
			typeof this.$addressLine1 !== "undefined"
			&& this.$addressLine0.length > 0
		) {
			this.$addressLine1.val(add1);
			this.triggerInput(this.$addressLine1[0]);
		}

		if (typeof this.$suburbField !== "undefined") {
			this.$suburbField.val(locality);
			this.triggerInput(this.$suburbField[0]);
		}

		if (typeof this.$stateField !== "undefined") {
			this.$stateField.val(administrative_area_level_1);
			this.triggerInput(this.$stateField[0]);
		}

		if (typeof this.$postcodeField !== "undefined") {
			this.$postcodeField.val(postcode);
			this.triggerInput(this.$postcodeField[0]);
		}

		if (typeof this.$countryField !== "undefined") {
			this.$countryField.val(countryCode);
		}

		$(document).trigger("address-validation-complete");
	}
}

AddressAutocomplete.DEFAULTS = {
	componentForm: {
		post_box: "long_name",
		premise: "long_name",
		subpremise: "long_name",
		street_number: "short_name",
		sublocality_level_1: "short_name",
		route: "long_name",
		locality: "long_name",
		administrative_area_level_1: "short_name",
		administrative_area_level_2: "short_name",
		country: "short_name",
		postal_code: "short_name",
		postal_town: "short_name",
	},
};

plugin(PLUGIN_NAME, AddressAutocomplete);

export function exec() {
	$(document).ready(() => {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/address-autocomplete/index.js